import React, { useState, useMemo } from 'react';
import { priceByMortgagePayment, mortgagePaymentByPrice } from '@search/vtbeco-frontend-core/view/filters/helpers/priceHelper';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';
import { LAND_MORTGAGE_PERCENT, MIN_HOUSE_PRICE, getRandomImageFromPrice } from './constants';

type LandMortgageProps = {
    payment: number;
    propertyCost: number;
    isLandPriceIncluded: boolean;
    isMobile: boolean;
}

export function useLandMortgageForm({ payment, propertyCost, isLandPriceIncluded, isMobile }: LandMortgageProps) {
    const staticPath = useStaticPathConfig();
    const [ isPaymentLower, setIsPaymentLower ] = useState(false);

    const calculatedValues = useMemo(() => {
        const creditSum = priceByMortgagePayment(payment, LAND_MORTGAGE_PERCENT);
        let tipSum = creditSum;

        if (isLandPriceIncluded) {
            tipSum += propertyCost;
        }

        const tipPayment = isLandPriceIncluded ? mortgagePaymentByPrice(propertyCost + MIN_HOUSE_PRICE, LAND_MORTGAGE_PERCENT) : mortgagePaymentByPrice(MIN_HOUSE_PRICE, LAND_MORTGAGE_PERCENT);

        setIsPaymentLower(payment < tipPayment || isNaN(creditSum));

        const src = getRandomImageFromPrice(payment, isMobile);

        const imgSrc = `${staticPath}${src}`;

        return ({
            creditSum,
            tipPayment,
            imgSrc
        });
    }, [ payment, isLandPriceIncluded ]);

    return ({
        calculatedValues,
        isPaymentLower,
    }
    );
}
